/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';
import BtnVoltar from '../../../../components/bntVoltar';

/*Import Requisição API*/
import api from '../../../../api';

import { NumericFormat } from 'react-number-format';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import { useToast } from '../../../../context/ToastContext';

export default function EditarProduto() {
    const location = useLocation();
    const id_produto = location.state?.id_produto;

    const [produto, setProduto] = useState({
        nome: '',
        descricao: '',
        descricao_longa: '',
        codigo_barras: '',
        marca: '',
        status: 'ativo',
        id_categoria: '',
        id_fornecedor: '',
        variacoes: []
    });

    const [categorias, setCategorias] = useState([]);
    const [fornecedores, setFornecedores] = useState([]);
    const [id, setIdUsuario] = useState('');
    const [draggedImage, setDraggedImage] = useState(null);
    const navigate = useNavigate();

    const { showToast } = useToast();

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                } else {
                    console.error('Erro na resposta:', response.data);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };
        buscarDadosUsuario();
    }, []);

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    /* Modal de Categoria */
    const CaixaModalCategoria = useRef(null);
    const [modalCategoriaAberto, setModalCategoriaAberto] = useState(false);
    const [novaCategoria, setNovaCategoria] = useState({
        nome: '',
        descricao: '',
        id_categoria_pai: ''
    });

    /* Modal de Fornecedor */
    const CaixaModalFornecedor = useRef(null);
    const [modalFornecedorAberto, setModalFornecedorAberto] = useState(false);
    const [novoFornecedor, setNovoFornecedor] = useState({
        nome: '',
        cnpj: '',
        telefone: '',
        email: '',
        site: '',
        contato_nome: '',
        contato_email: '',
        cep: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: ''
    });

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
        CaixaModalCategoria.current = document.getElementById("CaixaModalCategoria");
        CaixaModalFornecedor.current = document.getElementById("CaixaModalFornecedor");
    }, []);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    /* Funções do Modal de Categoria */
    const abrirModalCategoria = () => {
        setNovaCategoria({ nome: '', descricao: '', id_categoria_pai: '' });
        setModalCategoriaAberto(true);
        if (CaixaModalCategoria.current) {
            CaixaModalCategoria.current.showModal();
        }
    };

    const fecharModalCategoria = () => {
        setModalCategoriaAberto(false);
        setNovaCategoria({ nome: '', descricao: '', id_categoria_pai: '' });
        CaixaModalCategoria.current?.close();
    };

    const salvarCategoria = async (e) => {
        e.preventDefault();
        
        if (!novaCategoria.nome.trim()) {
            setTexto('O nome da categoria é obrigatório.');
            abrirModalAviso();
            return;
        }

        try {
            const response = await api.post('/categorias', {
                nome: novaCategoria.nome,
                descricao: novaCategoria.descricao,
                id_categoria_pai: novaCategoria.id_categoria_pai || null,
                usuario_id: id
            });

            if (response.data.success) {
                // Atualizar lista de categorias
                const categoriasResponse = await api.get('/listarcategorias');
                setCategorias(categoriasResponse.data.categorias);
                
                // Selecionar automaticamente a nova categoria
                setProduto({ ...produto, id_categoria: response.data.id.toString() });
                
                showToast('Categoria cadastrada com sucesso!', 'success');
                fecharModalCategoria();
            }
        } catch (error) {
            console.error('Erro ao cadastrar categoria:', error);
            setTexto(error.response?.data?.message || 'Erro ao cadastrar categoria.');
            abrirModalAviso();
        }
    };

    /* Funções do Modal de Fornecedor */
    const abrirModalFornecedor = () => {
        setNovoFornecedor({ 
            nome: '', cnpj: '', telefone: '', email: '', site: '', 
            contato_nome: '', contato_email: '', cep: '', logradouro: '', 
            numero: '', complemento: '', bairro: '', cidade: '', estado: '' 
        });
        setModalFornecedorAberto(true);
        if (CaixaModalFornecedor.current) {
            CaixaModalFornecedor.current.showModal();
        }
    };

    const fecharModalFornecedor = () => {
        setModalFornecedorAberto(false);
        setNovoFornecedor({ 
            nome: '', cnpj: '', telefone: '', email: '', site: '', 
            contato_nome: '', contato_email: '', cep: '', logradouro: '', 
            numero: '', complemento: '', bairro: '', cidade: '', estado: '' 
        });
        CaixaModalFornecedor.current?.close();
    };

    const formatarCNPJ = (valor) => {
        const numeros = valor.replace(/\D/g, '');
        if (numeros.length <= 14) {
            return numeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        }
        return valor;
    };

    const formatarTelefone = (valor) => {
        const numeros = valor.replace(/\D/g, '');
        if (numeros.length <= 10) {
            return numeros.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
        } else if (numeros.length <= 11) {
            return numeros.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
        }
        return valor;
    };

    const formatarCEP = (valor) => {
        const numeros = valor.replace(/\D/g, '');
        return numeros.replace(/^(\d{5})(\d{3})$/, '$1-$2').slice(0, 9);
    };

    const buscarEnderecoPorCep = async (cep) => {
        const cepLimpo = cep.replace(/\D/g, '');
        if (cepLimpo.length !== 8) return;
        
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
            const data = await response.json();
            if (!data.erro) {
                setNovoFornecedor(prev => ({
                    ...prev,
                    logradouro: data.logradouro || '',
                    bairro: data.bairro || '',
                    cidade: data.localidade || '',
                    estado: data.uf || ''
                }));
            }
        } catch (error) {
            console.error('Erro ao buscar CEP:', error);
        }
    };

    const salvarFornecedor = async (e) => {
        e.preventDefault();
        
        if (!novoFornecedor.nome.trim()) {
            setTexto('O nome do fornecedor é obrigatório.');
            abrirModalAviso();
            return;
        }

        if (!novoFornecedor.cnpj.trim()) {
            setTexto('O CNPJ é obrigatório.');
            abrirModalAviso();
            return;
        }

        if (!novoFornecedor.email.trim()) {
            setTexto('O e-mail é obrigatório.');
            abrirModalAviso();
            return;
        }

        if (!novoFornecedor.cep.trim()) {
            setTexto('O CEP é obrigatório.');
            abrirModalAviso();
            return;
        }

        try {
            const cnpjLimpo = novoFornecedor.cnpj.replace(/\D/g, '');
            const telefoneLimpo = novoFornecedor.telefone.replace(/\D/g, '');
            const cepLimpo = novoFornecedor.cep.replace(/\D/g, '');

            const response = await api.post('/fornecedores', {
                fornecedor: {
                    nome: novoFornecedor.nome,
                    cnpjcpf: cnpjLimpo,
                    telefone: telefoneLimpo,
                    email_contato: novoFornecedor.email,
                    site: novoFornecedor.site,
                    nome_contato: novoFornecedor.contato_nome,
                    email_contato_secundario: novoFornecedor.contato_email
                },
                endereco: {
                    cep: cepLimpo,
                    logradouro: novoFornecedor.logradouro,
                    numero: novoFornecedor.numero,
                    complemento: novoFornecedor.complemento,
                    bairro: novoFornecedor.bairro,
                    cidade: novoFornecedor.cidade,
                    estado: novoFornecedor.estado
                },
                usuario_id: id
            });

            if (response.data.success) {
                // Atualizar lista de fornecedores
                const fornecedoresResponse = await api.get('/listarfornecedores');
                setFornecedores(fornecedoresResponse.data.fornecedores || []);
                
                // Selecionar automaticamente o novo fornecedor
                setProduto({ ...produto, id_fornecedor: response.data.id_fornecedor.toString() });
                
                showToast('Fornecedor cadastrado com sucesso!', 'success');
                fecharModalFornecedor();
            }
        } catch (error) {
            console.error('Erro ao cadastrar fornecedor:', error);
            setTexto(error.response?.data?.message || 'Erro ao cadastrar fornecedor.');
            abrirModalAviso();
        }
    };

    // Carregar produto e dados adicionais
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchProduto = async () => {
            try {
                const response = await api.get(`/produtoadm/${id_produto}`, {
                    params: { usuarioId: 1 }
                });
                console.log(response.data);

                const produtoRecebido = response.data.produto || {};
                const variacoes = Array.isArray(produtoRecebido.variacoes)
                    ? produtoRecebido.variacoes
                    : [];

                // As imagens já vêm do banco de dados em formato de URL (ImageKit)
                // Não precisa fazer requisição para o Drive
                setProduto({ ...produtoRecebido, variacoes: variacoes });
            } catch (error) {
                console.error('Erro ao buscar produto:', error);
            } finally {
                setLoading(false);
            }
        };

        if (id_produto) {
            setLoading(true);
            fetchProduto();
        }
    }, [id_produto]);

    useEffect(() => {
        const carregarDados = async () => {
            try {
                const categoriasResponse = await api.get('/listarcategorias');
                setCategorias(categoriasResponse.data.categorias);

                const fornecedoresResponse = await api.get('/listarfornecedores');
                setFornecedores(fornecedoresResponse.data.fornecedores || []);
            } catch (error) {
                console.error('Erro ao carregar categorias ou fornecedores:', error.response?.data || error.message);
            }
        };
        carregarDados();
    }, []);

    const addImageToVariation = (index, file) => {
        setProduto((prevProduto) => {
            const updatedVariacoes = prevProduto.variacoes.map((variacao, idx) => {
                if (idx === index) {
                    const novasImagens = [...variacao.imagens];
                    if (!novasImagens.some(img => img.name === file.name)) {
                        novasImagens.push(file);
                    }
                    return { ...variacao, imagens: novasImagens };
                }
                return variacao;
            });
            return { ...prevProduto, variacoes: updatedVariacoes };
        });
    };

    function handleImageChange(varIndex, e) {
        const files = Array.from(e.target.files);
        e.target.value = null;

        setProduto(prev => {
            const novas = [...prev.variacoes];
            const existingFiles = novas[varIndex].imagens.filter(img => img instanceof File);
            const existingNames = new Set(existingFiles.map(f => f.name));

            const uniqueNew = files.filter(f => !existingNames.has(f.name));
            novas[varIndex].imagens = [
                ...novas[varIndex].imagens,
                ...uniqueNew
            ];
            return { ...prev, variacoes: novas };
        });
    }

    const handleDrop = (e, index) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        files.forEach((file) => addImageToVariation(index, file));
    };

    const handleImageDrop = (index, targetIndex) => {
        if (draggedImage === null) return;
        const updatedVariacoes = [...produto.variacoes];
        const imagens = [...updatedVariacoes[index].imagens];
        const [movedImage] = imagens.splice(draggedImage, 1);
        imagens.splice(targetIndex, 0, movedImage);
        updatedVariacoes[index].imagens = imagens;
        setProduto({ ...produto, variacoes: updatedVariacoes });
        setDraggedImage(null);
    };

    // Alterar valores das variações
    const handleVariacaoChange = (index, campo, valor) => {
        setProduto((prevProduto) => {
            const updatedVariacoes = [...prevProduto.variacoes];
            updatedVariacoes[index][campo] = valor;
            return { ...prevProduto, variacoes: updatedVariacoes };
        });
    };

    // Adicionar uma nova variação
    const handleAddVariação = () => {
        setProduto(prevState => ({
            ...prevState,
            variacoes: [
                ...prevState.variacoes,
                {
                    tamanho: '',
                    cor: '',
                    material: '',
                    tipo: '',
                    unidades_por_pacote: 1,
                    preco_compra: '',
                    preco_varejo: '',
                    preco_atacado: '',
                    estoque: '',
                    sku: '',
                    peso: '',
                    altura: '',
                    largura: '',
                    profundidade: '',
                    imagens: [],
                }
            ]
        }));
    };

    const handleRemoveVariacao = (indexToRemove) => {
        if (indexToRemove === 0) {
            showToast('Você não pode excluir a variação principal.', 'error');
            return;
        }

        setProduto(prev => {
            const removidosAnteriores = Array.isArray(prev.removidos)
                ? prev.removidos
                : [];

            const novasVariações = prev.variacoes.filter((_, i) => i !== indexToRemove);

            const idRemovido = prev.variacoes[indexToRemove]?.id_variacao;

            return {
                ...prev,
                variacoes: novasVariações,
                removidos: idRemovido
                    ? [...removidosAnteriores, idRemovido]
                    : removidosAnteriores
            };
        });
    };



    // Remover imagem de uma variação
    const handleRemoveImage = (index, imageIndex) => {
        const newVariacoes = [...produto.variacoes];
        newVariacoes[index].imagens = newVariacoes[index].imagens.filter((_, i) => i !== imageIndex);
        setProduto({ ...produto, variacoes: newVariacoes });
    };

    // Converter valor de moeda para número
    function parseCurrency(value) {
        if (!value) return 0;
        const numericValue = value.replace(/[^\d,-]/g, '').replace(',', '.');
        return parseFloat(numericValue);
    }

    const normalizeNumber = (str) => {
        const s = (str || "").toString().replace(',', '.').trim();
        const n = parseFloat(s);
        return isNaN(n) ? "0.00" : n.toFixed(2);
    };

    const defaultImagePath = '/assets/image/SemImagem.jpg';
    let defaultImageFileCache = null;

    const getDefaultImageFile = async () => {
        if (defaultImageFileCache) return defaultImageFileCache;
        const response = await fetch(defaultImagePath);
        const blob = await response.blob();
        defaultImageFileCache = new File([blob], 'SemImagem.jpg', { type: blob.type || 'image/jpeg' });
        return defaultImageFileCache;
    };

    const ensureVariationsWithDefaultImage = async (variacoes = []) => {
        const defaultFile = await getDefaultImageFile();
        return variacoes.map((variacao) => {
            const imagens = Array.isArray(variacao.imagens) ? variacao.imagens : [];
            if (imagens.length > 0) return variacao;
            return { ...variacao, imagens: [defaultFile] };
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);

        try {
            // ============================================
            // VALIDAÇÃO DE CAMPOS PRINCIPAIS
            // ============================================
            const errosValidacao = [];

            // Validar nome (3-100 caracteres)
            if (!produto.nome?.trim()) {
                errosValidacao.push('Nome é obrigatório');
            } else if (produto.nome.length < 3) {
                errosValidacao.push('Nome deve ter no mínimo 3 caracteres');
            } else if (produto.nome.length > 100) {
                errosValidacao.push('Nome não pode exceder 100 caracteres');
            }

            // Validar descrição (máximo 250 caracteres)
            if (!produto.descricao?.trim()) {
                errosValidacao.push('Descrição é obrigatória');
            } else if (produto.descricao.length > 250) {
                errosValidacao.push('Descrição não pode exceder 250 caracteres');
            }

            // Validar descrição longa
            if (!produto.descricao_longa?.trim()) {
                errosValidacao.push('Descrição longa é obrigatória');
            }

            // Validar código de barras
            if (!produto.codigo_barras?.trim()) {
                errosValidacao.push('Código de barras é obrigatório');
            } else if (!/^\d+$/.test(produto.codigo_barras)) {
                errosValidacao.push('Código de barras deve conter apenas números');
            } else if (![8, 12, 13].includes(produto.codigo_barras.length)) {
                errosValidacao.push('Código de barras deve ter 8, 12 ou 13 dígitos');
            }

            // Validar marca
            if (!produto.marca?.trim()) {
                errosValidacao.push('Marca é obrigatória');
            }

            // Validar categoria
            if (!produto.id_categoria) {
                errosValidacao.push('Categoria é obrigatória');
            }

            // Validar fornecedor
            if (!produto.id_fornecedor) {
                errosValidacao.push('Fornecedor é obrigatório');
            }

            // ============================================
            // VALIDAÇÃO DE VARIAÇÕES
            // ============================================
            const variacoesComImagem = await ensureVariationsWithDefaultImage(produto.variacoes);
            const skusUsados = new Set();
            variacoesComImagem.forEach((variacao, index) => {
                // Validar SKU
                if (!variacao.sku?.trim()) {
                    errosValidacao.push(`SKU é obrigatório na variação ${index + 1}`);
                } else if (variacao.sku.length > 50) {
                    errosValidacao.push(`SKU na variação ${index + 1} não pode exceder 50 caracteres`);
                }

                // Validar SKU duplicado
                const skuNormalizado = variacao.sku?.toUpperCase().trim();
                if (skuNormalizado && skusUsados.has(skuNormalizado)) {
                    errosValidacao.push(`SKU '${variacao.sku}' está duplicado`);
                }
                if (skuNormalizado) {
                    skusUsados.add(skuNormalizado);
                }

                // Validar preços
                const preco_compra = parseFloat(variacao.preco_compra);
                if (isNaN(preco_compra) || preco_compra < 0) {
                    errosValidacao.push(`Preço de compra inválido na variação ${index + 1}`);
                }
                if (preco_compra > 999999.99) {
                    errosValidacao.push(`Preço de compra não pode ser maior que R$ 999999.99 na variação ${index + 1}`);
                }

                const preco_varejo = parseFloat(variacao.preco_varejo);
                if (isNaN(preco_varejo) || preco_varejo < 0) {
                    errosValidacao.push(`Preço de varejo inválido na variação ${index + 1}`);
                }
                if (preco_varejo > 999999.99) {
                    errosValidacao.push(`Preço de varejo não pode ser maior que R$ 999999.99 na variação ${index + 1}`);
                }

                const preco_atacado = parseFloat(variacao.preco_atacado);
                if (isNaN(preco_atacado) || preco_atacado < 0) {
                    errosValidacao.push(`Preço de atacado inválido na variação ${index + 1}`);
                }
                if (preco_atacado > 999999.99) {
                    errosValidacao.push(`Preço de atacado não pode ser maior que R$ 999999.99 na variação ${index + 1}`);
                }

                // Validar estoque
                const estoque = parseInt(variacao.estoque);
                if (isNaN(estoque) || estoque < 0) {
                    errosValidacao.push(`Estoque inválido na variação ${index + 1}`);
                }
                if (estoque > 999999) {
                    errosValidacao.push(`Estoque não pode ser maior que 999999 na variação ${index + 1}`);
                }

                const unidadesPorPacote = parseInt(variacao.unidades_por_pacote, 10);
                if (isNaN(unidadesPorPacote) || unidadesPorPacote <= 0) {
                    errosValidacao.push(`Unidades por pacote inválido na variação ${index + 1}`);
                }

            });

            // Se houver erros, mostrar e retornar
            if (errosValidacao.length > 0) {
                setTexto(`Corrija os campos abaixo:\n${errosValidacao.join('\n')}`);
                abrirModalAviso();
                return;
            }

            const formData = new FormData();
            formData.append("id_produto", id_produto);
            formData.append("nome", produto.nome.trim());
            formData.append("descricao", produto.descricao.trim());
            formData.append("descricao_longa", produto.descricao_longa?.trim() || "");
            formData.append("codigo_barras", produto.codigo_barras?.trim() || "");
            formData.append("marca", produto.marca?.trim() || "");
            formData.append('status', (produto.status || 'ativo').toLowerCase());
            formData.append("id_categoria", produto.id_categoria);
            formData.append("id_fornecedor", produto.id_fornecedor);

            const variacoes = variacoesComImagem.map((variacao) => ({
                id_variacao: variacao.id_variacao || null,
                tamanho: variacao.tamanho || "",
                cor: variacao.cor || "",
                material: variacao.material || "",
                tipo: variacao.tipo || "",
                unidades_por_pacote: parseInt(variacao.unidades_por_pacote, 10) || 0,
                preco_compra: normalizeNumber(variacao.preco_compra) || "0",
                preco_varejo: normalizeNumber(variacao.preco_varejo) || "0",
                preco_atacado: normalizeNumber(variacao.preco_atacado) || "0",
                estoque: variacao.estoque || "0",
                sku: variacao.sku?.trim() || "",
                peso: variacao.peso || "0",
                altura: variacao.altura || "0",
                largura: variacao.largura || "0",
                profundidade: variacao.profundidade || "0",
                imagensExistentes: variacao.imagens
                    .filter((img) => typeof img === "string" && img.trim() !== ""),
                imagensNovas: variacao.imagens.filter((img) => img instanceof File),
            }));

            console.log("Variações enviadas:", JSON.stringify(variacoes, null, 2));

            formData.append("variacoes", JSON.stringify(variacoes));
            formData.append("removidos", JSON.stringify(produto.removidos || []));

            variacoes.forEach((variacao, i) => {
                variacao.imagensNovas.forEach((file, idx) => {
                    console.log(`Adicionando nova imagem variação[${i}][${idx}] =`, file.name);
                    formData.append(`variacoes[${i}][imagensNovas][]`, file);
                });
            });

            for (let [key, value] of formData.entries()) {
                console.log(`FormData: ${key} =`, value instanceof File ? value.name : value);
            }

            const response = await api.put(`/produtos/${id_produto}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            console.log("Produto atualizado com sucesso:", response.data);
            showToast("Produto atualizado com sucesso!", "success");
            setTimeout(() => navigate("/menu/produtos_e_estoque"), 1500);
        } catch (error) {
            console.error("Erro ao atualizar produto:", error.response?.data || error.message);
            
            let mensagemErro = 'Nao foi possivel atualizar o produto.';
            
            if (error.response?.status === 400) {
                if (error.response.data?.errors?.length > 0) {
                    mensagemErro = `Validacao falhou:\n${error.response.data.errors.join('\n')}`;
                } else {
                    mensagemErro = error.response.data?.message || mensagemErro;
                }
            } else if (error.response?.status === 409) {
                mensagemErro = error.response.data?.message || 'SKU duplicado. Ajuste a variacao e tente novamente.';
            } else if (error.response?.status === 413) {
                mensagemErro = 'Arquivo muito grande. Envie imagens menores.';
            } else {
                mensagemErro = error.response?.data?.message || error.message || mensagemErro;
            }
            
            showToast(mensagemErro, "error");
        } finally {
            setLoading(false);
        }
    };

    const getGoogleDriveUrl = (url) => {
        if (url.includes('export=view')) return url;

        const idMatch = url.match(/id=([A-Za-z0-9_-]+)/);
        if (idMatch && idMatch[1]) {
            return `https://drive.google.com/uc?export=view&id=${idMatch[1]}`;
        }
        return url;
    };

    return (
        <section className='container-principal-produtosEestoque'>

            <dialog id='CaixaDeDialogoAviso' className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className='dialog-texto'>
                        <p>{texto}</p>
                        <button id='botao' onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <dialog id='CaixaModalCategoria' className={modalCategoriaAberto ? 'open' : ''}>
                <div className='conteudo-dialog alterar-dados'>
                    <div className='dialog-texto'>
                        <h2>Adicionar Categoria</h2>
                        <form className='form-alterar-dados' onSubmit={salvarCategoria}>
                            <label>Nome da Categoria: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nome">
                                <input
                                    type="text"
                                    value={novaCategoria.nome}
                                    onChange={(e) => setNovaCategoria({ ...novaCategoria, nome: e.target.value })}
                                    placeholder="Digite o nome da categoria"
                                    required
                                />
                            </div>

                            <label>Descrição:</label>
                            <div className="input-descricao">
                                <textarea
                                    value={novaCategoria.descricao}
                                    onChange={(e) => setNovaCategoria({ ...novaCategoria, descricao: e.target.value })}
                                    placeholder="Digite a descrição (opcional)"
                                    rows="3"
                                />
                            </div>

                            <label>Categoria Raiz (Pai):</label>
                            <div className="input-categoria-pai">
                                <select
                                    value={novaCategoria.id_categoria_pai}
                                    onChange={(e) => setNovaCategoria({ ...novaCategoria, id_categoria_pai: e.target.value })}
                                >
                                    <option value="">Nenhuma (Categoria Principal)</option>
                                    {categorias && Array.isArray(categorias) && categorias.map((categoria) => (
                                        <option key={categoria.id} value={categoria.id}>
                                            {categoria.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className='bnts-decisao'>
                                <button type='submit' className='bnt-sim'>
                                    Salvar
                                </button>
                                <button type='button' className='bnt-nao' onClick={fecharModalCategoria}>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </dialog>

            <dialog id='CaixaModalFornecedor' className={modalFornecedorAberto ? 'open' : ''}>
                <div className='conteudo-dialog alterar-dados'>
                    <div className='dialog-texto'>
                        <h2>Adicionar Fornecedor</h2>
                        <form className='form-alterar-dados' onSubmit={salvarFornecedor}>
                            <label>Nome do Fornecedor: <span className="span-obrigatorio">*</span></label>
                            <div className="input-nome">
                                <input
                                    type="text"
                                    value={novoFornecedor.nome}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, nome: e.target.value })}
                                    placeholder="Digite o nome do fornecedor"
                                    required
                                />
                            </div>

                            <label>CNPJ: <span className="span-obrigatorio">*</span></label>
                            <div className="input-cnpj">
                                <input
                                    type="text"
                                    value={novoFornecedor.cnpj}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, cnpj: formatarCNPJ(e.target.value) })}
                                    placeholder="00.000.000/0000-00"
                                    maxLength="18"
                                    required
                                />
                            </div>

                            <label>Telefone: <span className="span-obrigatorio">*</span></label>
                            <div className="input-telefone">
                                <input
                                    type="text"
                                    value={novoFornecedor.telefone}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, telefone: formatarTelefone(e.target.value) })}
                                    placeholder="(00) 00000-0000"
                                    maxLength="15"
                                    required
                                />
                            </div>

                            <label>Email: <span className="span-obrigatorio">*</span></label>
                            <div className="input-email">
                                <input
                                    type="email"
                                    value={novoFornecedor.email}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, email: e.target.value })}
                                    placeholder="contato@fornecedor.com"
                                    required
                                />
                            </div>

                            <label>Site:</label>
                            <div className="input-site">
                                <input
                                    type="url"
                                    value={novoFornecedor.site}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, site: e.target.value })}
                                    placeholder="https://www.exemplo.com"
                                />
                            </div>

                            <label>Nome do Contato:</label>
                            <div className="input-contato-nome">
                                <input
                                    type="text"
                                    value={novoFornecedor.contato_nome}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, contato_nome: e.target.value })}
                                    placeholder="Nome da pessoa de contato"
                                />
                            </div>

                            <label>Email do Contato:</label>
                            <div className="input-contato-email">
                                <input
                                    type="email"
                                    value={novoFornecedor.contato_email}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, contato_email: e.target.value })}
                                    placeholder="email.contato@fornecedor.com"
                                />
                            </div>

                            <h3 style={{ marginTop: '20px', marginBottom: '10px' }}>Endereço</h3>

                            <label>CEP: <span className="span-obrigatorio">*</span></label>
                            <div className="input-cep">
                                <input
                                    type="text"
                                    value={novoFornecedor.cep}
                                    onChange={(e) => {
                                        const cepFormatado = formatarCEP(e.target.value);
                                        setNovoFornecedor({ ...novoFornecedor, cep: cepFormatado });
                                        if (cepFormatado.replace(/\D/g, '').length === 8) {
                                            buscarEnderecoPorCep(cepFormatado);
                                        }
                                    }}
                                    placeholder="00000-000"
                                    maxLength="9"
                                    required
                                />
                            </div>

                            <label>Logradouro: <span className="span-obrigatorio">*</span></label>
                            <div className="input-logradouro">
                                <input
                                    type="text"
                                    value={novoFornecedor.logradouro}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, logradouro: e.target.value })}
                                    placeholder="Rua, Avenida, etc."
                                    required
                                />
                            </div>

                            <label>Número: <span className="span-obrigatorio">*</span></label>
                            <div className="input-numero">
                                <input
                                    type="text"
                                    value={novoFornecedor.numero}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, numero: e.target.value })}
                                    placeholder="Número"
                                    required
                                />
                            </div>

                            <label>Complemento:</label>
                            <div className="input-complemento">
                                <input
                                    type="text"
                                    value={novoFornecedor.complemento}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, complemento: e.target.value })}
                                    placeholder="Apartamento, sala, etc."
                                />
                            </div>

                            <label>Bairro: <span className="span-obrigatorio">*</span></label>
                            <div className="input-bairro">
                                <input
                                    type="text"
                                    value={novoFornecedor.bairro}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, bairro: e.target.value })}
                                    placeholder="Bairro"
                                    required
                                />
                            </div>

                            <label>Cidade: <span className="span-obrigatorio">*</span></label>
                            <div className="input-cidade">
                                <input
                                    type="text"
                                    value={novoFornecedor.cidade}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, cidade: e.target.value })}
                                    placeholder="Cidade"
                                    required
                                />
                            </div>

                            <label>Estado: <span className="span-obrigatorio">*</span></label>
                            <div className="input-estado">
                                <input
                                    type="text"
                                    value={novoFornecedor.estado}
                                    onChange={(e) => setNovoFornecedor({ ...novoFornecedor, estado: e.target.value })}
                                    placeholder="UF"
                                    maxLength="2"
                                    required
                                />
                            </div>

                            <div className='bnts-decisao'>
                                <button type='submit' className='bnt-sim'>
                                    Salvar
                                </button>
                                <button type='button' className='bnt-nao' onClick={fecharModalFornecedor}>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main className='main-cadastroProduto'>
                <MenuLateral />
                <section className='conteudo-produtosEestoque'>
                    <div className='titulo-produtosEestoque'>
                        <h1><span>Produtos e Estoque</span> &gt; Edição de Produto</h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Editando dados do produto...</h2>
                        </div>
                    ) : (
                        <div className='perfil-cadastro-produtosEestoque'>
                            <h2>Edite os dados do produto</h2>
                            <section className='forms-Editarproduto'>
                                {/* Campos principais do Produto */}
                                <label htmlFor="nome">Nome: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-nome">
                                    <input
                                        id="nome"
                                        value={produto.nome}
                                        onChange={(e) => setProduto({ ...produto, nome: e.target.value })}
                                        type="text"
                                        placeholder="Digite o nome do produto"
                                        minLength="3" // Nome com no mínimo 3 caracteres
                                        maxLength="100" // Limite para evitar nomes muito longos
                                        className="input-field"
                                    />
                                </div>

                                {/* Descrição */}
                                <label htmlFor="descricao">Descrição: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-descricao">
                                    <textarea
                                        id="descricao"
                                        value={produto.descricao}
                                        onChange={(e) => setProduto({ ...produto, descricao: e.target.value })}
                                        placeholder="Digite uma breve descrição"
                                        maxLength="250" // Limite de caracteres
                                        rows="3"
                                        className="textarea-field"
                                    />
                                </div>

                                {/* Descrição Longa */}
                                <label htmlFor="descricao_longa">Descrição Longa: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-descricao_longa">
                                    <textarea
                                        id="descricao_longa"
                                        value={produto.descricao_longa}
                                        onChange={(e) => setProduto({ ...produto, descricao_longa: e.target.value })}
                                        placeholder="Digite uma descrição detalhada (aceita quebras de linha, emojis e HTML simples como <span style='color:#131C46; font-size:18px'>texto</span>)"
                                        rows="6"
                                        className="textarea-field"
                                    />
                                </div>
                                <small className='descricao-longa-hint'>Suporta quebras de linha, emojis e HTML simples: span, p, br, ul, ol, li, strong, em (apenas color e font-size no style).</small>

                                {/* Código de Barras */}
                                <label htmlFor="codigo_barras">Código de Barras (EAN/UPC): <span className='span-obrigatorio'>*</span></label>
                                <div className="input-codigo_barras">
                                    <input
                                        id="codigo_barras"
                                        value={produto.codigo_barras}
                                        onChange={(e) => setProduto({ ...produto, codigo_barras: e.target.value })}
                                        type="text"
                                        placeholder="Digite o código de barras"
                                        maxLength="13"
                                        pattern="\d{8}|\d{12}|\d{13}" // Aceita EAN-8, EAN-13 ou UPC-A
                                        title="Digite um código válido com 8, 12 ou 13 dígitos"
                                        className="input-field"
                                    />
                                </div>

                                {/* Marca */}
                                <label htmlFor="marca">Marca: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-marca">
                                    <input
                                        id="marca"
                                        value={produto.marca}
                                        onChange={(e) => setProduto({ ...produto, marca: e.target.value })}
                                        type="text"
                                        placeholder="Digite a marca do produto"
                                        className="input-field"
                                    />
                                </div>

                                {/* Status */}
                                <label htmlFor="status">Status: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-status">
                                    <select
                                        id="status"
                                        value={produto.status}
                                        onChange={(e) => setProduto({ ...produto, status: e.target.value })}
                                        className="select-field"
                                    >
                                        <option value="ativo">Ativo</option>
                                        <option value="inativo">Inativo</option>
                                    </select>
                                </div>

                                {/* Categoria */}
                                <label htmlFor="categoria">Categoria: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-categoria">
                                    <select
                                        id="categoria"
                                        value={produto.id_categoria}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            if (selectedValue === 'add-categoria') {
                                                abrirModalCategoria();
                                            } else {
                                                setProduto({ ...produto, id_categoria: selectedValue });
                                            }
                                        }}
                                        className="select-field"
                                    >
                                        <option value="">Selecione uma Categoria</option>
                                        {categorias && Array.isArray(categorias) && categorias.map((categoria) => (
                                            <option key={categoria.id} value={categoria.id}>
                                                {categoria.nome}
                                            </option>
                                        ))}
                                        {/* Opção para adicionar nova categoria */}
                                        <option value="add-categoria">+ Adicionar Categoria</option>
                                    </select>
                                </div>

                                {/* Fornecedor */}
                                <label htmlFor="fornecedor">Fornecedor: <span className='span-obrigatorio'>*</span></label>
                                <div className="input-fornecedor">
                                    <select
                                        id="fornecedor"
                                        value={produto.id_fornecedor}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            if (selectedValue === 'add-fornecedor') {
                                                abrirModalFornecedor();
                                            } else {
                                                setProduto({ ...produto, id_fornecedor: selectedValue });
                                            }
                                        }}
                                        className="select-field"
                                    >
                                        <option value="">Selecione um Fornecedor</option>
                                        {fornecedores && Array.isArray(fornecedores) && fornecedores.map((fornecedor) => (
                                            <option key={fornecedor.id} value={fornecedor.id}>
                                                {fornecedor.nome}
                                            </option>
                                        ))}
                                        {/* Opção para adicionar novo fornecedor */}
                                        <option value="add-fornecedor">+ Adicionar Fornecedor</option>
                                    </select>
                                </div>

                                {Array.isArray(produto.variacoes) && produto.variacoes.map((variacao, index) => (
                                    <div key={index}>
                                        <div className="variacao-header">
                                            {index !== 0 && (
                                                <>
                                                    <h3 className="variacao-titulo">
                                                        {`Variação ${index}`}
                                                    </h3>
                                                    <button
                                                        className="bnt-excluirVariacao"
                                                        onClick={() => handleRemoveVariacao(index)}
                                                        disabled={index === 0 || produto.variacoes.length === 1}
                                                        style={{ display: produto.variacoes.length === 1 && index === 0 ? 'none' : 'flex' }}
                                                    >
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>

                                                        <p>Remover</p>
                                                    </button>
                                                </>
                                            )}
                                        </div>
                                        {/* Campo Tamanho */}
                                        <label>Tamanho: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-tamanho">
                                            <input
                                                value={variacao.tamanho}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].tamanho = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite o tamanho (Opcional)'
                                            />
                                        </div>

                                        {/* Campo Cor */}
                                        <label>Cor: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-cor">
                                            <input
                                                value={variacao.cor}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].cor = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite a cor (Opcional)'
                                            />
                                        </div>

                                        {/* Campo Material */}
                                        <label>Material: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-material">
                                            <input
                                                value={variacao.material}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].material = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite o material (Opcional)'
                                            />
                                        </div>

                                        {/* Campo Tipo */}
                                        <label>Tipo:</label>
                                        <div className="input-tipo">
                                            <input
                                                value={variacao.tipo || ''}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].tipo = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite o tipo (Opcional)'
                                            />
                                        </div>

                                        {/* Campo SKU */}
                                        <label>SKU: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-sku">
                                            <input
                                                value={variacao.sku}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].sku = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite um código SKU único'
                                                maxLength={50}
                                            />
                                        </div>

                                        {/* Campos com restrições específicas */}

                                        {/* Preço de Compra */}
                                        <label>Preço de Compra: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-preco_compra">
                                            <CurrencyInput
                                                prefix="R$ "
                                                decimalSeparator=","
                                                groupSeparator="."
                                                decimalsLimit={2}
                                                allowNegativeValue={false}
                                                placeholder="R$ 0,00"
                                                value={produto.variacoes[index].preco_compra}
                                                onValueChange={(value) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].preco_compra = value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                            />
                                        </div>

                                        {/* Preço de Varejo */}
                                        <label>Preço de Varejo: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-preco_varejo">
                                            <CurrencyInput
                                                prefix="R$ "
                                                decimalSeparator=","
                                                groupSeparator="."
                                                decimalsLimit={2}
                                                allowNegativeValue={false}
                                                placeholder="R$ 0,00"
                                                value={produto.variacoes[index].preco_varejo}
                                                onValueChange={(value) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].preco_varejo = value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                            />
                                        </div>

                                        {/* Preço de Atacado */}
                                        <label>Preço de Atacado: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-preco_atacado">
                                            <CurrencyInput
                                                prefix="R$ "
                                                decimalSeparator=","
                                                groupSeparator="."
                                                decimalsLimit={2}
                                                allowNegativeValue={false}
                                                placeholder="R$ 0,00"
                                                value={produto.variacoes[index].preco_atacado}
                                                onValueChange={(value) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].preco_atacado = value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                            />
                                        </div>

                                        {/* Estoque */}
                                        <label>Estoque: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-estoque">
                                            <input
                                                value={variacao.estoque}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].estoque = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type='number'
                                                min="0"
                                                placeholder='Digite a quantidade de estoque'
                                            />
                                        </div>

                                        {/* Unidades por pacote */}
                                        <label>Unidades por pacote: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-unidades-por-pacote">
                                            <input
                                                value={variacao.unidades_por_pacote ?? ''}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].unidades_por_pacote = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type='number'
                                                min="1"
                                                placeholder='Digite as unidades por pacote'
                                            />
                                        </div>

                                        {/* SKU */}
                                        <label>SKU:</label>
                                        <div className="input-sku">
                                            <input
                                                value={variacao.sku}
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].sku = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="text"
                                                placeholder='Digite o SKU (Opcional)'
                                            />
                                        </div>

                                        {/* Peso */}
                                        <label>Peso: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-peso">
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    placeholder="Digite o peso do produto"
                                                    value={variacao.peso || ''}
                                                    onChange={(e) => {
                                                        const newVariacoes = [...produto.variacoes];
                                                        const inputValue = e.target.value;

                                                        // Atualiza o valor do peso inputado
                                                        newVariacoes[index].peso = inputValue;

                                                        // Realiza a conversão para gramas ou kg com base na unidade selecionada
                                                        const pesoEmGramas = newVariacoes[index].unidadePeso === 'kg'
                                                            ? inputValue * 1000  // Converte kg para g
                                                            : inputValue;        // Mantém o valor em g

                                                        // Atualiza o campo 'peso' com o valor convertido
                                                        newVariacoes[index].peso = pesoEmGramas;

                                                        setProduto({ ...produto, variacoes: newVariacoes });
                                                    }}
                                                />

                                                <select
                                                    value={variacao.unidadePeso || 'g'}
                                                    onChange={(e) => {
                                                        const newVariacoes = [...produto.variacoes];
                                                        const unidadeSelecionada = e.target.value;

                                                        // Atualiza a unidade selecionada
                                                        newVariacoes[index].unidadePeso = unidadeSelecionada;

                                                        // Realiza a conversão para gramas ou kg com base na unidade selecionada
                                                        const pesoEmGramas = unidadeSelecionada === 'kg'
                                                            ? (variacao.peso || 0) * 1000  // Converte kg para g
                                                            : (variacao.peso || 0);         // Mantém o valor em g

                                                        // Atualiza o campo 'peso' com o valor convertido
                                                        newVariacoes[index].peso = pesoEmGramas;

                                                        setProduto({ ...produto, variacoes: newVariacoes });
                                                    }}
                                                    style={{ marginLeft: '8px' }}
                                                >
                                                    <option value="g">g</option>
                                                    <option value="kg">kg</option>
                                                </select>
                                            </div>
                                        </div>


                                        {/* Dimensões (A x L x P) */}
                                        <label>Dimensões (A x L x P): <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-dimensoes">
                                            <input
                                                value={produto.variacoes[index].altura || ''}  // Corrigido para usar o estado correto
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].altura = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="number"
                                                min="0"
                                                placeholder="A (cm)"
                                            />
                                            <p>X</p>
                                            <input
                                                value={produto.variacoes[index].largura || ''}  // Corrigido para usar o estado correto
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].largura = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="number"
                                                min="0"
                                                placeholder="L (cm)"
                                            />
                                            <p>X</p>
                                            <input
                                                value={produto.variacoes[index].profundidade || ''}  // Corrigido para usar o estado correto
                                                onChange={(e) => {
                                                    const newVariacoes = [...produto.variacoes];
                                                    newVariacoes[index].profundidade = e.target.value;
                                                    setProduto({ ...produto, variacoes: newVariacoes });
                                                }}
                                                type="number"
                                                min="0"
                                                placeholder="P (cm)"
                                            />
                                        </div>

                                        <label>Imagens: <span className='span-obrigatorio'>*</span></label>
                                        <div className="input-imagens">
                                            <div
                                                className="image-preview"
                                                onDragOver={(e) => e.preventDefault()}
                                                onDrop={(e) => handleDrop(e, index)}
                                            >
                                                {variacao.imagens.map((imagem, imageIndex) => {
                                                    const imageSrc =
                                                        imagem instanceof File
                                                            ? URL.createObjectURL(imagem)
                                                            : typeof imagem === "string"
                                                                ? getGoogleDriveUrl(imagem)
                                                                : imagem.url;

                                                    return (
                                                        <div
                                                            className="image-item"
                                                            key={`${index}-${imageIndex}`}
                                                            draggable
                                                            onDragStart={() => setDraggedImage(imageIndex)}
                                                            onDragOver={(e) => e.preventDefault()}
                                                            onDrop={() => handleImageDrop(index, imageIndex)}
                                                        >
                                                            <img
                                                                src={imageSrc}
                                                                alt={`Imagem ${imageIndex + 1}`}
                                                            />
                                                            <button
                                                                type="button"
                                                                className="remove-button"
                                                                onClick={() => handleRemoveImage(index, imageIndex)}
                                                            >
                                                                <svg
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 20 20"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333"
                                                                        strokeWidth="2.08333"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    );
                                                })}

                                                <div
                                                    className="upload-box"
                                                    onClick={() => document.getElementById(`upload-${index}`).click()}
                                                >
                                                    <span>+</span>
                                                    <input
                                                        name={`variacoes[${index}][imagens][]`}
                                                        id={`upload-${index}`}
                                                        type="file"
                                                        multiple
                                                        onChange={(e) => handleImageChange(index, e)}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                ))}
                                <button type="button" className='bnt-addVariacao' onClick={handleAddVariação}>+ Adicionar Variação</button>
                                <button onClick={handleSubmit} className='bnt-cadastroProduto' >Editar Produto</button>
                            </section>
                        </div>
                    )}
                </section>
            </main>
            <Rodape />

        </section>
    );
}
